import {
  getList,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
import { BOUserDetails, BOUserDetailsDTO } from "./boUserDetails";
/* eslint-disable import/export */
export abstract class GetBOUserDetailsRPC implements
  LeoRPC<GetBOUserDetailsRPC.Request, GetBOUserDetailsRPC.Response, GetBOUserDetailsRPC.Errors.Errors>
{
  abstract execute(
    request: GetBOUserDetailsRPC.Request
  ): Promise<LeoRPCResult<GetBOUserDetailsRPC.Response, GetBOUserDetailsRPC.Errors.Errors>>;
}

export namespace GetBOUserDetailsRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {}

  export class Request implements LeoRPCRequest {
    readonly isGetBOUserDetailsRPCRequest: boolean = true;
    toDTO(): RequestDTO {
      return {}
    }
  }

  Request.prototype.toString = function toString(): string {
    return `GetBOUserDetailsRPC.Request`;
  };

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {
    boUserDetails: BOUserDetailsDTO[];
  }
  
  export class Response implements LeoRPCResponse {
    readonly isGetBOUserDetailsResponse: boolean = true;
  
    readonly boUserDetails: BOUserDetails[];
  
    static readonly constraints = {
      "boUserDetails": {
        "minSize": 1,
      }
    }
  
    constructor(
    boUserDetails: BOUserDetails[]
    ) {
      Response.validateBoUserDetails(boUserDetails);
      this.boUserDetails = boUserDetails;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const boUserDetails = getList<BOUserDetailsDTO, BOUserDetails>(
        dto,
        "boUserDetails",
        BOUserDetails.fromDTO,
        InvalidResponseBoUserDetailsError
      );
      return new Response(
        boUserDetails
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          boUserDetails: this.boUserDetails.map((e: BOUserDetails) => { return e.toDTO() })
      };
      return dto;
    }
    private static validateBoUserDetails = (boUserDetails: BOUserDetails[]): void => {
      if(boUserDetails.length < 1) {
        throw new InvalidResponseBoUserDetailsMinSizeError(
          1,
          `Attribute boUserDetails is too short. Size is ${boUserDetails.length}. Min size is 1.`
        );
      }
    }
    
  }
  
  Response.prototype.toString = function toString(): string {
    return `GetBOUserDetails(boUserDetails='${this.boUserDetails}')`;
  };
  


  export namespace Errors {

    export type Errors = any;
    export type ErrorsDTO = any;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}


export class InvalidResponseBoUserDetailsError extends GetBOUserDetailsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseBoUserDetailsError";
  }
}

export class InvalidResponseBoUserDetailsMinSizeError extends InvalidResponseBoUserDetailsError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseBoUserDetailsMinSizeError";
  }
}

